<script setup>
import CustomButton from "@/components/Button/Button.vue";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const showPassword = ref(false);
const showPasswordIcon = computed(() => {
    return showPassword.value ? '/assets/icons/svg/Hide_24x24.svg' : '/assets/icons/svg/Show_24x24.svg';
});

defineEmits(['show-register', 'forgot-password']);
</script>

<template>
    <div class="flex flex-col gap-8 py-12 max-w-[400px] mainContainer">
        <h1 class="responsive-title-5 font-semibold self-start headerText">{{ t('changePassword.title') }}</h1>
        <div class="my-6 w-full">
            <VTextField :label="t('changePassword.currentPassword')" variant="underlined"
                :type="showPassword ? 'text' : 'password'">
                <template v-slot:append-inner>
                    <div class="w-6 cursor-pointer" @click="showPassword = !showPassword" v-if="showPassword">
                        <img src="@/assets/icons/svg/Hide_24x24.svg" alt='hide' width="64">
                    </div>
                    <div class="w-6 cursor-pointer" @click="showPassword = !showPassword" v-else>
                        <img src="@/assets/icons/svg/Show_24x24.svg" alt='show' width="64">
                    </div>
                </template>
            </VTextField>
            <VTextField :label="t('changePassword.newPassword')" variant="underlined"
                :type="showPassword ? 'text' : 'password'">
            </VTextField>
            <VTextField :label="t('changePassword.reenterNewPassword')" variant="underlined"
                :type="showPassword ? 'text' : 'password'">
            </VTextField>
        </div>
        <div class="text-xs">{{ t('changePassword.passwordHint') }}</div>
        <CustomButton size="medium" type="black" :rounded="true" class="w-1/2 mb-6 max-w-[200px] responsive-body-medium">
            {{ t('changePassword.changePasswordButton') }}
        </CustomButton>
    </div>
    <div class="responsive-body-xsmall font-bold mainContainerX">
        {{ t('changePassword.deactivateText') }}
        <span class="underline">{{ t('changePassword.deactivateLink') }}</span>
    </div>
</template>

<style scoped>
@media (max-width: 768px) {
    .btn {
        font-size: 12px;
    }

    .mainContainer {
        padding: 34px 20px;
        width: 100%;
        max-width: 100%;
        gap: 5px;
    }

    .mainContainerX {
        width: 100%;
        max-width: 100%;
        padding: 0 20px;
    }

    .headerText {
        font-size: 20px;
    }
}
</style>
